import React, { Fragment, useState } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row } from 'reactstrap';
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { AddCategory, Categories, Image, Name, Save, Type } from "../../../Constant";
import { addCategory, addCategoryRole } from "../../../CommonUrl";
import { useSelector } from "react-redux";
import { postClientUrlWithToken } from "../../../Utils/restUtils";
import { toast } from 'react-toastify';
import Typeahead from "../../../CommonElements/TypeAhead";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Transparentspinner from "../../Common/Loader/Transparentspinner";

const schema = yup.object().shape({
    name: yup.string().required().label('Name'),
    type: yup.mixed().required().label('Type'),
})

const CategoryForm = () => {
    const { register, handleSubmit, control, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
    })
    const authState = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const form = new FormData();
    const [image, setImage] = useState('');
    const [loading, setLoading] = useState(false); 
    const [selectedType, setSelectedType] = useState('');

    const options = [
        { value: "expense", label: "Expense" },
        { value: "income", label: "Income" },
        { value: "item", label: "Item" },
        { value: "other", label: "Other" },
    ];

    const handleLogoChange = (event) => {
        const selectedFile = event.target.files[0];
        setImage(selectedFile);
    }

    const onSubmit = async (data) => {
        setLoading(true);
        form.append("name", data.name);
        form.append("type", data.type.value);
        if (data.type.value === 'item' && data.image && data.image[0]) {
            form.append("image", data.image[0]);
        }
        const addCategoryResponse = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? addCategory : addCategoryRole, form, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
        if (addCategoryResponse.status === 200) {
            if (addCategoryResponse.data.status === true) {
                toast.success(addCategoryResponse.data.message)
                navigate(`${process.env.PUBLIC_URL}/settings/categories`);
            } else {
                toast.error(addCategoryResponse.data.message)
                setLoading(false);
            }
        } else if (addCategoryResponse.status >= 400 && addCategoryResponse.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (addCategoryResponse.status >= 500 && addCategoryResponse.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    };
    return (
        <Fragment>
            {loading && (
                <Transparentspinner />
            )}

            <Breadcrumbs mainTitle={Categories} parent="Settings" title={Categories} />
            <Card>
                <CardHeader className="pb-0">
                    <H3>{AddCategory}</H3>
                </CardHeader>
                <CardBody>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="name">{Name} <span className="requireStar">*</span></Label>
                                <input className="form-control" id="name" type="text" {...register('name', { required: true })} />
                                <p className="text-danger">{errors.name?.message}</p>
                            </Col>
                            <Col md="6">
                                <Label className="form-label" >{Type} <span className="requireStar">*</span></Label>
                                <Controller
                                    name="type"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            options={options}
                                            onChange={(value) => {
                                                field.onChange(value);
                                                setSelectedType(value?.value);
                                            }}
                                            value={field.value}
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors.type?.message}</p>
                            </Col>
                        </Row>
                        <FormGroup>
                        </FormGroup>
                        {selectedType === 'item' && (
                            <Row>
                                <Col md="6">
                                    <Label className="form-label">{Image}</Label>
                                    <Controller
                                        name="image"
                                        control={control}
                                        render={({ field }) => (
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <Col md="8">
                                                    <input
                                                        {...register("image")}
                                                        className="form-control fileInputStyle"
                                                        type="file"
                                                        onChange={handleLogoChange}
                                                        accept=".png, .jpg, .jpeg"
                                                    />
                                                </Col>
                                                <Col md='4'>
                                                    <span className="imagestyle">
                                                        {image && <img src={URL.createObjectURL(image)} alt="logo" width="40px" height="40px" />}
                                                    </span>
                                                </Col>
                                            </div>
                                        )}
                                    />
                                    <span className="text-danger">{errors.logo && "logo is required"}</span>
                                </Col>
                            </Row>
                        )}
                        <FormGroup>
                        </FormGroup>
                        <Btn attrBtn={{ color: "primary" }} type="submit">{Save}</Btn>
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    )
}
export default CategoryForm;